// Single italic-serif line rendered above Surface A's MarginaliaTop when
// the user is replaying a completed Practice path. Acknowledges practice
// mode honestly without prescribing action. Per
// 2026-05-16-session-boundary-semantics-mini-spec.md §2.2 copy table.
//
// Editorial register: italic-serif `text-meta muted-fg`, no vermilion,
// no motion verb beyond inherited mount fade. Path-specific copy is
// chosen by the `path` prop.

export type PracticeModePath = 'learn' | 'quiz' | 'challenge'

const COPY: Record<PracticeModePath, string> = {
    learn: 'practice mode — your progress is already recorded',
    quiz: 'practice attempt — recorded in your history',
    challenge: 'practice mode — your certification stands',
}

export function PracticeModeLine({ path }: { path: PracticeModePath }) {
    return (
        <p className="font-serif text-meta text-muted-fg italic">
            {COPY[path]}
        </p>
    )
}
